import { render, staticRenderFns } from "./DigitalYuanNumber.vue?vue&type=template&id=4e89e5db&scoped=true&"
import script from "./DigitalYuanNumber.vue?vue&type=script&lang=js&"
export * from "./DigitalYuanNumber.vue?vue&type=script&lang=js&"
import style0 from "./DigitalYuanNumber.vue?vue&type=style&index=0&id=4e89e5db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e89e5db",
  null
  
)

export default component.exports